import { TablePagination } from 'components/molecules';
import { RepresentativeRow } from 'components/molecules/Representative/RepresentativeRow';
import { PaperCardTemplate } from 'components/templates/PaperCardTemplate';
import { useRepresentative } from 'hooks/useRepresentative';

import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useEffect } from 'react';

export const RepresentativeList: React.FC = () => {
  const {
    docs,
    loading,
    page,
    totalPages,
    handleNextPage,
    handlePreviousPage,
    handleRefresh,
  } = useRepresentative();

  useEffect(() => {
    handleRefresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PaperCardTemplate loading={loading}>
      <Table size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell component="th" scope="row">
              <Typography fontWeight={500} fontSize={14}>
                Nome do Representante
              </Typography>
            </TableCell>

            <TableCell>
              <Typography fontWeight={500} fontSize={14}>
                CPF
              </Typography>
            </TableCell>

            <TableCell>
              <Typography fontWeight={500} fontSize={14} color="#4B4B4B">
                Status
              </Typography>
            </TableCell>

            <TableCell align="center" width={50}>
              <Typography fontWeight={500} fontSize={14}>
                Ação
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>

        {docs?.length < 1 && (
          <Typography component="caption">
            <Box textAlign="center">
              Não possui nenhum representante cadastrado ainda.
            </Box>
          </Typography>
        )}

        <TableBody>
          {docs?.map((representative, index) => (
            <RepresentativeRow key={index} representative={representative} />
          ))}
        </TableBody>
      </Table>
      <TablePagination
        currentPage={page}
        maxPage={totalPages}
        onPreviousClick={handlePreviousPage}
        onNextClick={handleNextPage}
      />
    </PaperCardTemplate>
  );
};
